import React from 'react';
import {Box} from '@material-ui/core';
import LinearProgress from "@material-ui/core/LinearProgress";

const FormLoading = () => {

	return <Box mt={3} mb={3}>
                <LinearProgress />
            </Box>;
};

export default FormLoading;
